import { useMemo } from 'react'
import { useUser } from '../../../hooks/useUser'
import { GamerSection } from '../../../shared/types/navigation'
import type { IndividualSessionFeedbackData } from '../../../types/IndividualSessionFeedbackTypes'
import { hasUnreadLatestFeedback } from '../pages/helpers/latestSessionFeedbackHelpers'
import { hasUnreadProfileFeedback } from '../pages/helpers/myProfileHelpers'

/** The menu items whose page holds feedback the player has not read yet. */
export const useNewFeedbackSectionIds = (latestFeedback: IndividualSessionFeedbackData | undefined): GamerSection[] => {
  const { data: user } = useUser()

  return useMemo(() => {
    const sectionIds: GamerSection[] = []
    if (hasUnreadLatestFeedback(latestFeedback, user)) sectionIds.push(GamerSection.LATEST_SESSION_FEEDBACK)
    if (hasUnreadProfileFeedback(user)) sectionIds.push(GamerSection.MY_PROFILE)
    return sectionIds
  }, [latestFeedback, user])
}
